import Vue from 'vue'
import sensors from 'sa-sdk-javascript'
import store from '@/store'

// function getUrlParam(name) {
//   var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
//   var r = window.location.search.substr(1).match(reg)
//   if (r != null) {
//     return unescape(r[2])
//   } else {
//     return ''
//   }
// }

// const track_log = getUrlParam('track_log') || process.env.NODE_ENV !== 'production'
sensors.init({
  server_url: process.env.VUE_APP_TRACK_API,
  is_track_single_page: function() {
    return {
      $title: document.title
    }
  },
  use_client_time: true,
  send_type: 'beacon',
  show_log: false,
  heatmap: {
    collect_tags: {
      div: {
        max_level: 3 // 默认是 1，即只支持叶子 div。可配置范围是 [1, 2, 3],非该范围配置值，会被当作 1 处理。
      },
      li: true,
      img: true,
      svg: true
    },
    // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: 'default',
    get_vtrack_config: true,
    loadTimeout: 4 * 1000,
    // 是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'default',
    scroll_delay_time: 4 * 1000,
    scroll_event_duration: 18 * 1000 // 单位秒，预置属性停留时长 event_duration 的最大值。默认5个小时，也就是300分钟，18000秒。
  }
})
sensors.registerPage({
  platform_type: 'pc',
  platform_lang: 'zh',
  platform_site: 'china'
})
// 获取匿名 ID
sensors.quick('isReady', () => {
  const ids = sensors.quick('getAnonymousID')
  store.dispatch('SetAnonymousID', ids)
})

/**
 * 文档：https://docs.qq.com/sheet/DZGRjVmhha2RUZ3FV?tab=wl947n
 * el 元素
 * binding 参数
 * - value 传入的数据
 * -- type: url(url跳转)\normal(正常的埋点)\none(无需埋点) --- default: url
 * -- data: 原始方法需要的参数
 * -- callback: 原始方法名
 * -- url: 跳转的url
 * -- jumpWay: 跳转方式 _blank: 新窗口打开 else 当前
 * -- params: 神策埋点需要的数据
 * --- event: 事件名
 * --- data: 神策埋点需传入参数
 * vnode 虚拟dom
 * - context === this
 */
Vue.directive('point', (el, binding, vnode) => {
  el.onclick = () => {
    // e.preventDefault() // 阻止默认事件
    // 无需埋点 && 兼容公共组件
    if (binding.value.type === 'none') {
      vnode.context[binding.value.callback](binding.value.data)
      return false
    }
    sensors.track(binding.value.params.event, binding.value.params.data, () => {
      // 如果有callback说明是调用事件
      if (binding.value.type === 'normal') {
        vnode.context[binding.value.callback](binding.value.data)
      }
    })
  }
})

Vue.prototype.$sensors = sensors

export default sensors
